module.exports = __webpack_public_path__ + "app/admin/metrics/metrics.dump.modal-YTxPRdr9.html";